export default __webpack_public_path__ + "static/media/star_video.9365fe58.mp4";